import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Row, Col, Button, Input } from "reactstrap";
import AutoResizeInput from "../../components/AutoResizeInput";

/**
 * @param {Array<string>} affectedAttributes 
 * @param {function} onReorder(newOrder: string[]) - called when we reorder the array
 * @param {function} onRemoveItem(index: number) - remove one attribute
 * @param {function} onChangeItem(index: number, newValue: string)
 */
const AffectedAttributesList = ({
  affectedAttributes,
  onReorder,
  onRemoveItem,
  onChangeItem,
  onSave
}) => {

  const handleDragEnd = (result) => {
    if (!result.destination) return; // dropped outside the list

    const newOrder = Array.from(affectedAttributes);
    const [movedItem] = newOrder.splice(result.source.index, 1);
    newOrder.splice(result.destination.index, 0, movedItem);

    onReorder(newOrder);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="affected-attributes-droppable">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {affectedAttributes.map((attr, index) => (
              <Draggable
                key={`affected-attribute-${index}`}
                draggableId={`affected-attribute-${index}`}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      userSelect: "none",
                      marginBottom: "0.5rem",
                      padding: "0.3rem",
                      border: "1px solid #aeabab",
                      borderRadius: "5px",
                      ...provided.draggableProps.style
                    }}
                  >
                    <Row style={{ maxWidth: "100%" }}>
                      <Col xs={10}>
                        <AutoResizeInput
                          value={attr}
                          onChange={(e) => onChangeItem(index, e.target.value)}
                          //onBlur={onSave}
                        />
                      </Col>
                      <Col xs={2} style={{ display: "flex", alignItems: "center" }}>
                        <Button
                          color="outline-danger"
                          onClick={(e) => {
                            e.stopPropagation(); // avoid drag on button click
                            onRemoveItem(index);
                          }}
                        >
                          -
                        </Button>
                      </Col>
                    </Row>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default AffectedAttributesList;

